export const trustSignalsConfig = {
  image_metadata_as_expected: {
    title: 'Image Metadata As Expected',
    subtitle: 'Metadata matches the expected format',
    order: 4,
  },
  transactions_balance: {
    title: 'Transactions Balance',
    subtitle: 'Bank statement is balanced',
    order: 1,
  },
  image_pdf_expected: {
    title: 'Image PDF Expected',
    subtitle: 'Document format matches bank standard',
    order: 2,
  },
  location_match: {
    title: 'Location Match',
    subtitle: 'Photo location matches document address',
    order: 5,
  },
  photo_metadata_as_expected: {
    title: 'Camera Metadata As Expected',
    subtitle: 'Metadata corresponds with the capture device',
    order: 3,
  },
};
